// test2261
(2261 && 0);
